import { isInternetExplorer } from './common';

$(function searchAndHandleInteractiveScroll() {
    if ($(window).width() > 992 && !isInternetExplorer()) {
        $.each($('.section-scroll-interactive'), (_index, anchor) => {
            handleInteractiveScroll(anchor);
        });
    }
});

function handleInteractiveScroll(section) {
    let activeIndex = -1;
    let newPosition = 0;
    let prevIndex = 0;
    let isBreak = false;
    let reachedDesiredPosition = true;
    let previousPosition = 0;
    let actualPosition = 0;
    let circlePosition = 0;

    document.addEventListener(
        'scroll',
        () => {
            const docViewTop = $(window).scrollTop();

            if (isAbovePlugin(section)) {
                activeIndex = -1;
                showScrollBar();
                $.each($(section).find('.interactive-circle'), (_index, anchor) => {
                    $(anchor).removeClass('active');
                });
            }

            if (isUnderPlugin(section)) {
                activeIndex = 3;
                showScrollBar();
                $.each($(section).find('.interactive-circle'), (_index, anchor) => {
                    $(anchor).removeClass('active');
                });
            }

            if (docViewTop === Math.floor(newPosition)) {
                reachedDesiredPosition = true;
            }

            if (reachedDesiredPosition && isBreak) {
                setTimeout(() => {
                    allowScroll();
                }, 900);
            }

            actualPosition = $(window).scrollTop();

            if (!isBreak && reachedDesiredPosition && isPartOfElementInView(section)) {
                hideScrollbar();
                const interactiveElementPosition = $(section)
                    .find(`.interactive-item:eq(${activeIndex})`)
                    .offset();

                if (interactiveElementPosition) {
                    circlePosition = interactiveElementPosition.left;
                }

                if (actualPosition > previousPosition && activeIndex < 3) {
                    prevIndex = activeIndex;
                    activeIndex++;
                } else if (actualPosition < previousPosition && activeIndex > 0) {
                    prevIndex = activeIndex;
                    activeIndex--;
                } else {
                    return;
                }

                makeAnimations(section, activeIndex, prevIndex);

                const elemTop = $(`.interactive-item:eq(${activeIndex})`).offset().top;
                const elemBottom = elemTop + $(`.interactive-item:eq(${activeIndex})`).height();

                newPosition = elemBottom - $(window).height();
                reachedDesiredPosition = false;
                disableScroll();
                window.scrollTo({ top: elemBottom - $(window).height(), behavior: 'smooth' });
                setTimeInterval();
            }
            previousPosition = actualPosition;
        },
        { passive: true },
    );

    function makeAnimations(section, actualIndex, prevIndex) {
        const $newItem = $(section).find(`.interactive-item:eq(${actualIndex})`);
        const $prevItem = $(section).find(`.interactive-item:eq(${prevIndex})`);

        $newItem.addClass('active');
        $prevItem.removeClass('active');

        $.each($(section).find('.interactive-circle'), (index, anchor) => {
            if (index <= actualIndex) {
                $(anchor).addClass('active');
            } else {
                $(anchor).removeClass('active');
            }

            $(anchor).css('left', `${circlePosition - 100}px`);
        });
    }

    function setTimeInterval() {
        isBreak = true;
        setTimeout(() => {
            isBreak = false;
            reachedDesiredPosition = true;
        }, 1000);
    }

    function isPartOfElementInView(elem) {
        const docViewTop = $(window).scrollTop();
        const docViewBottom = docViewTop + $(window).height();

        const elemTop = $(elem).offset().top;
        const elemBottom = elemTop + $(elem).height();

        return docViewTop > elemTop && docViewBottom < elemBottom;
    }

    function isAbovePlugin(section) {
        const docViewTop = $(window).scrollTop();
        const sectionTop = $(section).offset().top;

        return docViewTop < sectionTop;
    }

    function isUnderPlugin(section) {
        const docViewTop = $(window).scrollTop();
        const docViewBottom = docViewTop + $(window).height();
        const sectionTop = $(section).offset().top;
        const sectionBottom = sectionTop + $(section).height();

        return docViewBottom > sectionBottom;
    }

    function disableScroll() {
        $('body').css('overflow', 'hidden');
    }

    function allowScroll() {
        $('body').css('overflow', 'visible');
    }

    function hideScrollbar() {
        $('body').addClass('hide-scrollbar');
    }

    function showScrollBar() {
        $('body').removeClass('hide-scrollbar');
    }
}



// WEBPACK FOOTER //
// ./js/interactive-scroll.js